export default __webpack_public_path__ + "static/media/request.5dc72b23.svg";